<template>
  <DetailsAccordion
    :error-description="i18n(translations.errorDescription)"
    :status
    @refresh="refresh"
  >
    <template #icon>
      <IconAvatar />
    </template>
    <template #title>
      {{
        i18n(translations.title, {
          firstName: customer?.firstName,
          lastName: customer?.lastName,
        })
      }}
    </template>
    <template #description>
      {{ i18n(translations.description) }}
    </template>
    <template #body>
      <ul v-if="orderline" class="grid grid-cols-1 gap-16 lg:grid-cols-2">
        <li>
          <p class="font-weight-body-2-bold">
            {{ i18n(translations.shippingAddress) }}
          </p>
          <Address :address="orderline.shippingAddress" />
          <p class="text-static-default-low break-words">
            {{ orderline.customerShippingEmail }}
          </p>
        </li>
        <li>
          <p class="font-weight-body-2-bold">
            {{ i18n(translations.billingAddress) }}
          </p>
          <Address :address="orderline.billingAddress" />
          <p class="text-static-default-low break-words">
            {{ orderline.customerInvoiceEmail }}
          </p>
        </li>
      </ul>
    </template>
  </DetailsAccordion>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconAvatar } from '@ds/icons/IconAvatar'

import { useOrderlineDetails } from '~/scopes/customer-care/pages/request/composables/useOrderlineDetails'

import Address from '../Address.vue'
import DetailsAccordion from '../DetailsAccordion/DetailsAccordion.vue'

import translations from './Customer.translations'

const i18n = useI18n()

const {
  customerDetails: { data, status, refresh },
} = useOrderlineDetails()

const { orderline, customer } = data
</script>
